import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import publicApi from '../services/public.api';
import { useLocation } from '../context/LocationContext';

const BannerTwo = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const { formatPrice, isCasaRegion, priceRegion } = useLocation();

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await publicApi.getCategoriesWithProducts(priceRegion);
                if (response.success && response.data) {
                    setCategories(response.data);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, [priceRegion]);

    // Normalize label for reliable matching (e.g. "Crèmerie" -> "cremerie")
    const normalizeLabelKey = (value) => {
        const text = String(value ?? '').trim().toLowerCase();
        return text.normalize('NFD').replace(/\p{Diacritic}/gu, '');
    };

    // Map API category names to the exact labels shown in the header dropdown
    const getCategoryLabel = (name) => {
        const key = normalizeLabelKey(name);

        const labelMap = {
            cremerie: 'CRÈMERIE',
            epicerie: 'ÉPICERIE',
            'gateaux mini sale': 'GÂTEAUX MINI SALÉS',
            'gateaux mini sucre': 'GÂTEAUX MINI SUCRÉS',
            'gateaux sable': 'GÂTEAUX SABLÉ',
            'les eaux': 'EAUX FLORALES',
            'nougat et chocolat': 'NOUGAT ET CHOCOLAT',
            'gateaux traditionnels': 'GÂTEAUX TRADITIONNELS',
        };

        return labelMap[key] || name;
    };

    // Get image URL
    const getImageUrl = (imagePath) => {
        return publicApi.getImageUrl(imagePath);
    };

    // Get the correct price based on location
    const getProductPrice = (product) => {
        if (isCasaRegion && product.price_casa) {
            return parseFloat(product.price_casa);
        }
        return parseFloat(product.price || 0);
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
    };

    return (
        <div className="banner-two">
            <div className="container container-lg">
                <div className="banner-two-wrapper d-flex align-items-start">
                    <div className="w-265 d-lg-block d-none flex-shrink-0">
                        <div className="responsive-dropdown style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 position-relative border-top-0">
                            <button
                                type="button"
                                className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                            >
                                <i className="ph ph-x" />{" "}
                            </button>
                            <div className="logo px-16 d-lg-none d-block">
                                <Link to="/" className="link">
                                    <img src="assets/images/logo/logo.png" alt="Logo" />
                                </Link>
                            </div>
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border spinner-border-sm text-main" role="status">
                                        <span className="visually-hidden">Chargement...</span>
                                    </div>
                                </div>
                            ) : (
                            <ul className="responsive-dropdown__list scroll-sm p-0 py-8 overflow-y-auto ">
                                {categories.slice(0, 14).map((category) => (
                                    <li 
                                        key={category.id} 
                                        className={`has-submenus-submenu ${activeCategory === category.id ? 'active-submenu' : ''}`}
                                        onClick={() => setActiveCategory(activeCategory === category.id ? null : category.id)}
                                    >
                                    <Link
                                        to="#"
                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                            <span>{getCategoryLabel(category.name)}</span>
                                        <span className="icon text-md d-flex ms-auto">
                                            <i className="ph ph-caret-right" />
                                        </span>
                                    </Link>
                                    {category.products && category.products.length > 0 && (
                                    <div 
                                        className="submenus-submenu py-16 px-16"
                                        style={activeCategory === category.id ? { 
                                            display: 'block', 
                                            opacity: 1, 
                                            visibility: 'visible',
                                            pointerEvents: 'auto'
                                        } : {}}
                                    >
                                        <h6 className="text-lg submenus-submenu__title mb-16">
                                                {getCategoryLabel(category.name)}
                                        </h6>
                                        <div className="row g-8">
                                                {category.products.slice(0, 4).map((product) => (
                                                    <div key={product.id} className="col-6">
                                                        <Link 
                                                            to={`/product-details/${product.id}`}
                                                            className="d-block border border-gray-100 rounded-8 p-8 text-center hover-border-main-600 transition-1"
                                                        >
                                                            <div className="mb-8" style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <img 
                                                                    src={getImageUrl(product.image)} 
                                                                    alt={product.name}
                                                                    style={{ maxHeight: '80px', maxWidth: '100%', objectFit: 'contain' }}
                                                                    onError={(e) => {
                                                                        e.target.src = 'assets/images/thumbs/product-two-img1.png';
                                                                    }}
                                                                />
                                                            </div>
                                                            <span className="text-xs text-gray-600 text-line-2 d-block mb-4">{product.name}</span>
                                                            <span className="text-sm fw-semibold text-main-600">{formatPrice(getProductPrice(product))} DH</span>
                                                        </Link>
                                            </div>
                                                ))}
                                        </div>
                                        {category.products.length > 4 && (
                                            <Link 
                                                to={`/shop?category=${category.id}`} 
                                                className="btn btn-sm w-100 mt-12 py-6"
                                                style={{ backgroundColor: '#000', color: '#fff', border: 'none' }}
                                            >
                                                Voir tout ({category.products.length})
                                            </Link>
                                        )}
                                    </div>
                                    )}
                                </li>
                                ))}
                            </ul>
                            )}
                        </div>
                    </div>
                    <div 
                        className="banner-item-two-wrapper banner-two-custom rounded-24 overflow-hidden position-relative arrow-center flex-grow-1 mb-0"
                    >
                        <div className="banner-item-two__slider">
                            <Slider {...settings}>
                                <div className="banner-item-two">
                                    <div className="banner-item-two__content">
                                        <span className="banner-two-text-white mb-8 h6">Tradition Fassi Authentique</span>
                                        <h2 className="banner-item-two__title bounce banner-two-text-white">
                                            Le Goût du Terroir Marocain
                                        </h2>
                                        <Link
                                            to="/shop"
                                            className="btn banner-two-btn d-inline-flex align-items-center rounded-pill gap-8"
                                        >
                                            Découvrir
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-shopping-cart-simple" />
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="banner-item-two__thumb position-absolute bottom-0">
                                        <img src="assets/images/thumbs/banner-two-img.png" alt="" />
                                    </div>
                                </div>
                                <div className="banner-item-two banner-item-two-second">
                                    <div className="banner-item-two__content">
                                        <span className="banner-two-text-white mb-8 h6">Qualité Premium Artisanale</span>
                                        <h2 className="banner-item-two__title bounce banner-two-text-white">
                                            Savourez Nos Délices Fassis
                                        </h2>
                                        <Link
                                            to="/shop"
                                            className="btn banner-two-btn d-inline-flex align-items-center rounded-pill gap-8"
                                        >
                                            Commander
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-shopping-cart-simple" />
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="banner-item-two__thumb position-absolute bottom-0">
                                        <img src="assets/images/thumbs/banner-two-img2.png" alt="" />
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerTwo
